import { trackingUtils } from '@debijenkorf/dbk-common';

import { wishlistOrCartEvent, type GA4ProductItemInput } from './ga4ProductModel';

type TrackWishlistChange = {
  type: 'add' | 'remove';
  item: GA4ProductItemInput;
};

export const trackWishlistChange = ({ type, item }: TrackWishlistChange) =>
  trackingUtils.pushToDataLayer(
    wishlistOrCartEvent(type === 'add' ? 'add_to_wishlist' : 'remove_from_wishlist', item),
  );
